import React from "react";
import { Card } from "./style";
import blanco from "../../assets/blanco.jpeg";
const Cards = ({ children, url = blanco }) => {
  return <Card url={url}>{children}</Card>;
};

export default Cards;
